// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes avMode__image__off {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}
@keyframes avMode__image__on {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.image.av-mode.av-mode__image > .image__inner.image__inner-av-mode {
  display: grid;
}
.image.av-mode.av-mode__image > .image__inner.image__inner-av-mode > .image__img {
  grid-area: 1/1;
}

html:not(.no-js):not(.prefers-reduced-motion) .is-visible .image--animate.loaded.av-mode.av-mode__image .image__img:not(:first-child) {
  opacity: 0;
}

.image.av-mode.av-mode__image > .image__inner > .image__img:first-child {
  opacity: 1;
}
.image.av-mode.av-mode__image > .image__inner > .image__img:not(:first-child) {
  opacity: 0;
}
.image.av-mode.av-mode__image.av-mode__on > .image__inner > .image__img:not(:first-child) {
  animation: 1.2s avMode__image__on forwards;
}
.image.av-mode.av-mode__image.av-mode__on > .image__inner > .image__img:first-child {
  animation: 1.2s avMode__image__off forwards;
}
.image.av-mode.av-mode__image.av-mode__off > .image__inner > .image__img:not(:first-child) {
  animation: 1.2s avMode__image__off forwards;
}
.image.av-mode.av-mode__image.av-mode__off > .image__inner > .image__img::first-child {
  animation: 1.2s avMode__image__on forwards;
}`, "",{"version":3,"sources":["webpack://./src/Common/components/shared.bundle/always-visible-mode/av-mode__image.scss"],"names":[],"mappings":"AAEA;EACE;IACE,UAAA;EADF;EAIA;IACE,UAAA;EAFF;AACF;AAKA;EACE;IACE,UAAA;EAHF;EAMA;IACE,UAAA;EAJF;AACF;AAWQ;EACE,aAAA;AATV;AAWU;EACE,cAAA;AATZ;;AAoBM;EACE,UAAA;AAjBR;;AA2BQ;EACE,UAAA;AAxBV;AA2BQ;EACE,UAAA;AAzBV;AA+BU;EACE,0CAAA;AA7BZ;AAgCU;EACE,2CAAA;AA9BZ;AAqCU;EACE,2CAAA;AAnCZ;AAsCU;EACE,0CAAA;AApCZ","sourcesContent":["@import './av-mode__vars.scss';\n\n@keyframes avMode__image__off {\n  from {\n    opacity: 1;\n  }\n\n  to {\n    opacity: 0;\n  }\n}\n\n@keyframes avMode__image__on {\n  from {\n    opacity: 0;\n  }\n\n  to {\n    opacity: 1;\n  }\n}\n\n.image {\n  &.av-mode {\n    &.av-mode__image {\n      > .image__inner {\n        &.image__inner-av-mode {\n          display: grid;\n\n          > .image__img {\n            grid-area: 1 / 1;\n          }\n        }\n      }\n    }\n  }\n}\n\nhtml:not(.no-js):not(.prefers-reduced-motion) .is-visible .image--animate.loaded {\n  &.av-mode {\n    &.av-mode__image {\n      .image__img:not(:first-child) {\n        opacity: 0;\n      }\n    }\n  }\n}\n\n.image {\n  &.av-mode {\n    &.av-mode__image {\n      > .image__inner {\n        > .image__img:first-child {\n          opacity: 1;\n        }\n\n        > .image__img:not(:first-child) {\n          opacity: 0;\n        }\n      }\n\n      &.av-mode__on {\n        > .image__inner {\n          > .image__img:not(:first-child) {\n            animation: $animation-duration avMode__image__on forwards;\n          }\n\n          > .image__img:first-child {\n            animation: $animation-duration avMode__image__off forwards;\n          }\n        }\n      }\n\n      &.av-mode__off {\n        > .image__inner {\n          > .image__img:not(:first-child) {\n            animation: $animation-duration avMode__image__off forwards;\n          }\n\n          > .image__img::first-child {\n            animation: $animation-duration avMode__image__on forwards;\n          }\n        }\n      }\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
